import { displayElement } from '@/helpers/DOM'

/**
 * @param {Element} button
 * @param {function():string} value
 */
function bindButtonCopy(button, value) {
    let timeout = null

    button.addEventListener('click', function () {
        clearTimeout(timeout)

        displayElement(button.querySelector('.icon-copy'), false)

        displayElement(button.querySelector('.icon-copied'), true)

        navigator.clipboard.writeText(value());

        timeout = setTimeout(function() {
            displayElement(button.querySelector('.icon-copy'), true)

            displayElement(button.querySelector('.icon-copied'), false)
        }, 3000)
    })
}

/**
 * @param {string|Element} [element]
 */
export function bindInputCopy(element = '.input-group-btn-copy') {
    const elements = element instanceof Element ?
        [element] :
        document.querySelectorAll(element);

    elements.forEach(function(container) {
        bindButtonCopy(container.querySelector('.input-group-prepend'), function() {
            return container.querySelector('input').value
        });
    })
}
